import Vue from 'vue'
import Router from 'vue-router'
import register from '@/components/login/register'
import login from '@/components/login/login'
import vip from '@/components/vip'
import myInfo from '@/components/myInfo'
import expertInfo from '@/components/expertInfo'
import workExp from '@/components/workExp'
import singleWorkExp from '@/components/singleWorkExp'
import idPhoto from '@/components/idPhoto'
import eduPhoto from '@/components/eduPhoto'
import skillPhoto from '@/components/skillPhoto'
import skill from '@/components/skill'
import singleSkill from '@/components/singleSkill'
import invitation from '@/components/invitation'
import protocal from '@/components/protocal'
import wallet from '@/components/wallet'
import recharge from '@/components/recharge'
import withdraw from '@/components/withdraw'
import orders from '@/components/orders'
import orderDetail from '@/components/orderDetail'
import glzh from '@/components/glzh'
import xgmm from '@/components/xgmm'
import enterpriseUsers from '@/components/enterpriseUsers'
import attention from '@/components/attention'
import sbxx from '@/components/sbxx'
import forgetpassword from '@/components/forgetpassword'
import rapidrepairs from '@/components/rapidrepairs'
import rapidrepairslist from '@/components/rapidrepairslist'
import quicksetup from '@/components/quicksetup'
import quicklycomplete from '@/components/quicklycomplete'
import normalrepairs from '@/components/normalrepairs'
import normalrepairslist from '@/components/normalrepairslist'
import normalcomplete from '@/components/normalcomplete'
import normaldone from '@/components/normaldone'
import userhomepage from '@/components/userhomepage'
import solution_logs from '@/components/solution/solution_logs'
import photo from '@/components/photo'
import engineer from '@/components/engineer'
import addmyInfo from '@/components/addmyInfo'
import detaillist from '@/components/detaillist'
import addfirmInfo from '@/components/addfirmInfo'
import records from '@/components/records'
import makeMemo from '@/components/makeMemo'
import addrate from '@/components/addrate'
import prgsdetail from '@/components/prgsdetail'
import cancelCause from '@/components/cancelCause'
import addexpertInfo from '@/components/addexpertInfo'
import cancel from '@/components/cancel'
import confirmfault from '@/components/confirmfault'
import finish from '@/components/finish'
import userevaluation from '@/components/userevaluation'
import myrecordcomplete from '@/components/myrecordcomplete'
import myrecorddone from '@/components/myrecorddone'
import faultType from '@/components/faultType'
import faultType1 from '@/components/faultType1'
import Devicelist from '@/components/Devicelist'
import Devicedetails from '@/components/Devicedetails'
import recordlist from '@/components/recordlist'
import smallbox from '@/components/smallbox'
import addphoto from '@/components/addphoto'
import binding from '@/components/binding'
import list from '@/components/Administrator/list'
import RepairOrder from '@/components/Administrator/RepairOrder'
import FastRepairOrder from '@/components/Administrator/FastRepairOrder'
import RepairSrvp from '@/components/repairs/RepairSrvp'
import RepairLog from '@/components/repairs/RepairLog'
import repair from '@/components/repair'
import RepairSolution from '@/components/repairs/RepairSolution'
import RegisterType from "@/components/login/RegisterType";
import Desiginate from "../components/repairs/Desiginate";
import Userpay from "../components/Pay/Userpay";
import Payinfo from "../components/Pay/Payinfo";
import Pay from "../components/Pay/Pay";
import needpay from "../components/Pay/needpay";
import Askpay from "../components/Pay/Askpay";
import Market from "../components/Market";
import filing from "../components/srvpproject/filing";
import filinglist from "../components/srvpproject/filinglist";
import filingorder from "../components/srvpproject/filingorder";
import srvprepairinfo from "../components/Indvrepair/srvprepairinfo";
import assistant from "../components/assistantinfo/assistant";
import assistantinfo from "../components/assistantinfo/assistantinfo";
import assistantorder from "../components/assistantinfo/assistantorder";
import viwocertificate from "../components/certificate/viwocertificate";
import resume from "../components/job/resume";
import apply from "../components/job/apply";
import resumelist from "../components/job/resumelist";
import Saleslog from "../components/Saleslog"
import Download from "../components/Download";
import filingjy from "../components/srvpproject-jy/filingjy";
import filinglistjy from "../components/srvpproject-jy/filinglistjy";
import filingorderjy from "../components/srvpproject-jy/filingorderjy";
import viwocertificatelist from "../components/certificate/viwocertificatelist";
import PcLogin from "../components/PcLogin";
import bondaccount from "../components/bondaccount";
import promptUpdate from "../components/promptUpdate"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/promptUpdate',
      name: 'promptUpdate',
      component: promptUpdate
    },
    {
      path: '/bondaccount',
      name: 'bondaccount',
      component: bondaccount
    },
    {
      path: '/PcLogin',
      name: 'PcLogin',
      component: PcLogin
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/saleslog',
      name: 'saleslog',
      component: Saleslog
    },
    {
      path: '/resumelist',
      name: 'resumelist',
      component: resumelist
    },
    {
      path: '/apply',
      name: 'apply',
      component: apply
    },
    {
      path: '/resume',
      name: 'resume',
      component: resume
    },
    {
      path: '/viwocertificatelist',
      name: 'viwocertificatelist',
      component: viwocertificatelist
    },
    {
      path: '/viwocertificate',
      name: 'viwocertificate',
      component: viwocertificate
    },
    {
      path: '/assistantorder',
      name: 'assistantorder',
      component: assistantorder
    },
    {
      path: '/assistantinfo',
      name: 'assistantinfo',
      component: assistantinfo
    },
    {
      path: '/assistant',
      name: 'assistant',
      component: assistant
    },
    {
      path: '/srvprepairinfo',
      name: 'srvprepairinfo',
      component: srvprepairinfo
    },
    {
      path: '/filingorder',
      name: 'filingorder',
      component: filingorder
    },
    {
      path: '/filinglist',
      name: 'filinglist',
      component: filinglist
    },
    {
      path: '/filing',
      name: 'filing',
      component: filing
    },
    {
      path: '/Market',
      name: 'Market',
      component: Market
    },
    {
      path: '/Askpay',
      name: 'Askpay',
      component: Askpay
    },
    {
      path: '/needpay',
      name: 'needpay',
      component: needpay
    },
    {
      path: '/Pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/Payinfo',
      name: 'Payinfo',
      component: Payinfo
    },
    {
      path: '/Userpay',
      name: 'Userpay',
      component: Userpay
    },
    {
      path: '/Desiginate',
      name: 'Desiginate',
      component: Desiginate
    },
    {
      path: '/register',
      name: 'register',
      component: register//() => import('@/components/login/register')
    },
    {
      path: '/login',
      name: 'login',
      component: login//() => import('@/components/login/login')
    },
    {
      path: '/',
      name: 'vip',
      component: vip,//() => import('@/components/vip'),
    },
    {
      path: '/myInfo',
      name: 'myInfo',
      component: myInfo,
      redirect: '/promptUpdate'
    },
    {
      path: '/expertInfo',
      name: 'expertInfo',
      component: expertInfo,
      redirect: '/promptUpdate'
    },
    {
      path: '/workExp',
      name: 'workExp',
      component: workExp//() => import('@/components/workExp')
    },
    {
      path: '/singleWorkExp',
      name: 'singleWorkExp',
      component: singleWorkExp//() => import('@/components/singleWorkExp')
    },
    {
      path: '/idPhoto',
      name: 'idPhoto',
      component: idPhoto//() => import('@/components/idPhoto')
    },
    {
      path: '/eduPhoto',
      name: 'eduPhoto',
      component: eduPhoto//() => import('@/components/eduPhoto')
    },
    {
      path: '/skillPhoto',
      name: 'skillPhoto',
      component: skillPhoto//() => import('@/components/skillPhoto')
    },
    {
      path: '/skill',
      name: 'skill',
      component: skill//() => import('@/components/skill')
    },
    {
      path: '/singleSkill',
      name: 'singleSkill',
      component: singleSkill//() => import('@/components/singleSkill')
    },
    {
      path: '/invitation',
      name: 'invitation',
      component: invitation//() => import('@/components/invitation')
    },
    {
      path: '/protocal',
      name: 'protocal',
      component: protocal//() => import('@/components/protocal')
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      redirect: '/promptUpdate'
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge//() => import('@/components/recharge')
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw//() => import('@/components/withdraw')
    },
    {
      path: '/orders',
      name: 'orders',
      component: orders//() => import('@/components/orders')
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail//() => import('@/components/orderDetail')
    },
    {
      path: '/glzh',
      name: 'glzh',
      component: glzh//() => import('@/components/glzh')
    },
    {
      path: '/xgmm',
      name: 'xgmm',
      component: xgmm//() => import('@/components/xgmm')
    },
    {
      path: '/enterpriseUsers',
      name: 'enterpriseUsers',
      component: enterpriseUsers//() => import('@/components/enterpriseUsers')
    },
    {
      path: '/attention',
      name: 'attention',
      component: attention//() => import('@/components/attention')
    },
    {
      path: '/sbxx',
      name: 'sbxx',
      component: sbxx//() => import('@/components/sbxx')
    },
    {
      path: '/forgetpassword',
      name: 'forgetpassword',
      component: forgetpassword//() => import('@/components/forgetpassword')
    },
    {
      path: '/rapidrepairs',
      name: 'rapidrepairs',
      component: rapidrepairs//() => import('@/components/rapidrepairs')
    },
    {
      path: '/rapidrepairslist',
      name: 'rapidrepairslist',
      component: rapidrepairslist//() => import('@/components/rapidrepairslist')
    },
    {
      path: '/quicksetup',
      name: 'quicksetup',
      component: quicksetup//() => import('@/components/quicksetup')
    },
    {
      path: '/quicklycomplete',
      name: 'quicklycomplete',
      component: quicklycomplete//() => import('@/components/quicklycomplete')
    },
    {
      path: '/normalrepairs',
      name: 'normalrepairs',
      component: normalrepairs//() => import('@/components/normalrepairs')
    },
    {
      path: '/normalrepairslist',
      name: 'normalrepairslist',
      component: normalrepairslist//() => import('@/components/normalrepairslist')
    },
    {
      path: '/normalcomplete',
      name: 'normalcomplete',
      component: normalcomplete//() => import('@/components/normalcomplete')
    },
    {
      path: '/normaldone',
      name: 'normaldone',
      component: normaldone//() => import('@/components/normaldone')
    },
    {
      path: '/userhomepage',
      name: 'userhomepage',
      component: userhomepage//() => import('@/components/userhomepage')
    },
    {
      path: '/solution_logs',
      name: 'solution_logs',
      component: solution_logs//() => import('@/components/solution/solution_logs')
    },
    {
      path: '/photo',
      name: 'photo',
      component: photo//() => import('@/components/photo')
    },
    {
      path: '/engineer',
      name: 'engineer',
      component: engineer//() => import('@/components/engineer')
    },
    {
      path: '/addmyInfo',
      name: 'addmyInfo',
      component: addmyInfo//() => import('@/components/addmyInfo')
    },
    {
      path: '/detaillist',
      name: 'detaillist',
      component: detaillist//() => import('@/components/detaillist')
    },
    {
      path: '/addfirmInfo',
      name: 'addfirmInfo',
      component: addfirmInfo//() => import('@/components/addfirmInfo')
    },
    {
      path: '/records',
      name: 'records',
      component: records//() => import('@/components/records')
    },
    {
      path: '/makeMemo',
      name: 'makeMemo',
      component: makeMemo//() => import('@/components/makeMemo')
    },
    {
      path: '/addrate',
      name: 'addrate',
      component: addrate//() => import('@/components/addrate')
    },
    {
      path: '/prgsdetail',
      name: 'prgsdetail',
      component: prgsdetail//() => import('@/components/prgsdetail')
    },
    {
      path: '/cancelCause',
      name: 'cancelCause',
      component: cancelCause//() => import('@/components/cancelCause')
    },
    {
      path: '/addexpertInfo',
      name: 'addexpertInfo',
      component: addexpertInfo//() => import('@/components/addexpertInfo')
    },
    {
      path: '/cancel',
      name: 'cancel',
      component: cancel//() => import('@/components/cancel')
    },
    {
      path: '/confirmfault',
      name: 'confirmfault',
      component: confirmfault//() => import('@/components/confirmfault')
    },
    {
      path: '/finish',
      name: 'finish',
      component: finish//() => import('@/components/finish')
    },
    {
      path: '/userevaluation',
      name: 'userevaluation',
      component: userevaluation//() => import('@/components/userevaluation')
    },
    {
      path: '/myrecord',
      name: 'filinglistjy',
      component: filinglistjy//() => import('@/components/myrecord')
    },
    {
      path: '/myrecordcomplete',
      name: 'myrecordcomplete',
      component: myrecordcomplete//() => import('@/components/myrecordcomplete')
    },
    {
      path: '/preparation',
      name: 'filingjy',
      component: filingjy//() => import('@/components/preparation')
    },
    {
      path: '/filingorderjy',
      name: 'filingorderjy',
      component: filingorderjy//() => import('@/components/preparation')
    },
    {
      path: '/myrecorddone',
      name: 'myrecorddone',
      component: myrecorddone//() => import('@/components/myrecorddone')
    },
    {
      path: '/faultType',
      name: 'faultType',
      component: faultType//() => import('@/components/faultType')
    },
    {
      path: '/faultType1',
      name: 'faultType1',
      component: faultType1//() => import('@/components/faultType1')
    },
    {
      path: '/Devicelist',
      name: 'Devicelist',
      component: Devicelist//() => import('@/components/Devicelist')
    },
    {
      path: '/Devicedetails',
      name: 'Devicedetails',
      component: Devicedetails//() => import('@/components/Devicedetails')
    },
    {
      path: '/recordlist',
      name: 'recordlist',
      component: recordlist//() => import('@/components/recordlist')
    },
    {
      path: '/smallbox',
      name: 'smallbox',
      component: smallbox//() => import('@/components/smallbox')
    },
    {
      path: '/addphoto',
      name: 'addphoto',
      component: addphoto//() => import('@/components/addphoto')
    },
    {
      path: '/binding',
      name: 'binding',
      component: binding//() => import('@/components/binding')
    },
    {
      path: '/list',
      name: 'list',
      component: list//() => import('@/components/Administrator/list')
    },
    {
      path: '/RepairOrder',
      name: 'RepairOrder',
      component: RepairOrder//() => import('@/components/Administrator/RepairOrder')
    },
    {
      path: '/FastRepairOrder',
      name: 'FastRepairOrder',
      component: FastRepairOrder//() => import('@/components/Administrator/FastRepairOrder')
    },
    {
      path: '/RepairSrvp',
      name: 'RepairSrvp',
      component: RepairSrvp//() => import('@/components/repairs/RepairSrvp')
    }, {
      path: '/RepairLog',
      name: 'RepairLog',
      component: RepairLog//() => import('@/components/repairs/RepairLog')
    }, {
      path: '/repair',
      name: 'repair',
      component: repair//() => import('@/components/repair')
    }, {
      path: '/RepairSolution',
      name: 'RepairSolution',
      component: RepairSolution//() => import('@/components/repairs/RepairSolution')
    }, {
      path: '/RegisterType',
      name: 'RegisterType',
      component: RegisterType
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js